import React, { useEffect, useRef, useState } from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import FlexRegIframe from './FlexRegIframe';
import Header from 'Components/header';
import useHeapTrack from '../../hooks/useHeapTrack';
import PanoPreview from '../PanoPreview';
import SparkleAnimation from './SparkleAnimation';
import APPILY_TYPE from '@src/constants/appilyTypeConstants';

interface Props {
  formTitle: string;
  formSubTitle: string;
  logo: string;
  onContinueClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  classes?: any;
  mainMediaUrl: string | null;
  mainMediaType: string | null;
  showIframe: boolean;
  setShowIframe: (show: boolean) => void;
  cxRedirectUrl?: string;
  appilyMode: string;
}

const AppilyAuthWelcome = ({
  formTitle,
  formSubTitle,
  logo,
  onContinueClick,
  classes,
  mainMediaUrl,
  mainMediaType,
  showIframe,
  setShowIframe,
  cxRedirectUrl,
  appilyMode,
}: Props) => {
  useHeapTrack(appilyMode === APPILY_TYPE.APPILY_IFRAME ? 'appily_auth_iframe_form_viewed' : 'appily_auth_form_viewed' );
  const holderRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState({ width: 800, height: 600 });

  useEffect(() => {
    const updateSize = () => {
      const el = holderRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        setDimensions({ width: rect.width, height: rect.height });
      }
    };

    updateSize(); // initial
    const resizeObserver = new ResizeObserver(updateSize);
    if (holderRef.current) {
      resizeObserver.observe(holderRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div>
      <div className={classes.appilyStack}>
        <div className={classes.appilyPageCongainer}>
          <div id="holder" ref={holderRef} className={classes.panoHolder}>
            <Header
              fieldIDs={[]}
              formTitle={formTitle}
              formSubTitle={formSubTitle}
              logo={logo}
              appilyAuth={true}
            />
          </div>
          {mainMediaType === 'panorama' && (
            <div className={classes.panoAnimHolder}>
              <PanoPreview
                imageUrl={mainMediaUrl}
                canvasWidth={dimensions.width}
                canvasHeight={dimensions.height}
              />
            </div>
          )}
          {mainMediaType === 'photo' && (
            <div
              style={{
                width: dimensions.width,
                height: dimensions.height,
                backgroundImage: `url(${mainMediaUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
          )}
        </div>
        <div className={classes.rightContainer}>
          <div className={classes.rightSizeController}>
            <h2 className={classes.subtitleText}>
              Let's personalize your experience!
            </h2>
            <p className={classes.paragraphText}>
              Create your free Appily College Search profile to personalize your
              tour with {formTitle}.
            </p>

            <button onClick={onContinueClick} className={classes.appilyButton}>
              Continue to personalize{' '}
              <div className={classes.sparkleHolder}>
                <SparkleAnimation />
              </div>
            </button>
            <div className={classes.appilyLogoContainer}>
              <img
                className={classes.appilyLogo}
                src="images/appily_logo_power.svg"
              />
            </div>
          </div>
        </div>
      </div>
      {showIframe && (
        <FlexRegIframe cxRedirectUrl={cxRedirectUrl} setShowIframe={setShowIframe} classes={classes} />
      )}
    </div>
  );
};

export default injectSheet(styleSheet)(AppilyAuthWelcome);
